require('./about/about');
require('./article-info/article-info');
require('./article/article');
require('./checkout-transit-order/checkout-transit-order');
require('./checkout/checkout');
require('./customer-card/customer-card');
require('./customer-info/customer-info');
require('./customer/customer');
require('./dashboard/dashboard');
require('./discount-rule/discount-rule');
require('./discount-rule/discount-rule');
require('./discount-settings/discount-settings');
require('./eos-edit/eos-edit');
require('./eos-overview/eos-overview');
require('./eos-submit-overview/eos-submit-overview');
require('./fiscal-eos/fiscal-eos');
require('./main/main');
require('./message-display/message-display');
require('./more/more');
require('./nav-bar/nav-bar');
require('./open-drawer/open-drawer');
require('./pin-menu/pin-menu');
require('./pos-app/pos-app');
require('./pos-controls/pos-controls');
require('./pos-dialog/pos-dialog');
require('./pos-pad/pos-pad');
require('./pos/pos');
require('./reason-editor/reason-editor');
require('./receipt-list/receipt-list');
require('./route/route');
require('./sales-transaction-summary/sales-transaction-summary');
require('./select-buffer/select-buffer');
require('./select-receipt/select-receipt');
require('./system-clock/system-clock');
require('./transit-order-summary/transit-order-summary');
require('./transit-order/transit-order');
require('./withdrawal-summary/withdrawal-summary');
require('./withdrawal/withdrawal');
